module.exports = __webpack_public_path__ + "media/icons/zmiana-wlasciciela@3x-3e043971.svg";